(() => {
  if (window.TJFitmentIndex) return;

  const normalize = (value) => String(value ?? '').normalize('NFC').replace(/\s+/g, ' ').trim();
  const makeAliases = new Map([
    ['benz', 'Mercedes-Benz'],
    ['mercedes', 'Mercedes-Benz'],
    ['mercedes benz', 'Mercedes-Benz'],
    ['mercedes-benz', 'Mercedes-Benz'],
    ['chevy', 'Chevrolet'],
  ]);
  const modelAliases = new Map([
    ['Escalade Iq/Iql', ['Escalade IQ', 'Escalade IQL']],
    ['F250/F350/F450 SUPER DUTY', ['F250 Super Duty', 'F350 Super Duty', 'F450 Super Duty']],
    ['F250/F350/F450 Super Duty', ['F250 Super Duty', 'F350 Super Duty', 'F450 Super Duty']],
    ['NX 250/350/350h/450h+', ['NX 250', 'NX 350', 'NX 350h', 'NX 450h+']],
    ['RX350/RX350h/RX450h+/RX500h', ['RX350', 'RX350h', 'RX450h+', 'RX500h']],
    ['RX 300/350/450H', ['RX 300', 'RX 350', 'RX 450H']],
    ['Ram 1500/2500/3500', ['Ram 1500', 'Ram 2500', 'Ram 3500']],
    ['Ram 1500/2500/3500 With CD player', ['Ram 1500 With CD player', 'Ram 2500 With CD player', 'Ram 3500 With CD player']],
    ['RAM 1500/2500/3500 Sliding Model', ['RAM 1500 Sliding Model', 'RAM 2500 Sliding Model', 'RAM 3500 Sliding Model']],
  ]);

  function canonicalMake(value) {
    const name = normalize(value);
    return makeAliases.get(name.toLowerCase()) || name;
  }

  function expandModels(value) {
    const raw = normalize(value);
    if (!raw) return [];
    if (modelAliases.has(raw)) return modelAliases.get(raw);
    if (/\b40\/20\/40\b|\b1\/4\b/.test(raw)) return [raw];
    if (!raw.includes('/')) return [raw];
    const parts = raw.split('/').map(normalize).filter(Boolean);
    if (parts.length < 2 || parts.length > 4) return [raw];
    const first = parts[0];
    const prefix = first.match(/^(.+?\s)(?=[\dA-Z][^\s]*$)/)?.[1] || '';
    return [...new Set(parts.map((part, index) => {
      if (index === 0) return part;
      if (prefix && !part.toLowerCase().startsWith(prefix.toLowerCase())) return `${prefix}${part}`;
      return part;
    }))];
  }

  function expandProduct(product) {
    if (!product || !Array.isArray(product.fitments)) return [];
    const structured = product.fitments.flatMap((fitment) => {
      const make = canonicalMake(fitment.make);
      const year = canonicalYear(fitment.year);
      if (!make || !year) return [];
      return expandModels(fitment.model).map((model) => ({ make, model, year }));
    });
    return [...new Map(structured.map((row) => [
      `${row.make.toLowerCase()}\u0001${row.model.toLowerCase()}\u0001${row.year}`, row,
    ])).values()];
  }

  function canonicalYear(value) {
    const raw = normalize(value).replace(/[–—]/g, '-').replace(/\s+/g, '');
    const match = raw.match(/^(\d{4})-(\d{2}|\d{4})$/);
    return match ? `${match[1]}-${match[2].length === 2 ? match[1].slice(0, 2) + match[2] : match[2]}` : raw;
  }

  function previewThemeId() {
    const url = new URL(location.href);
    return url.searchParams.get('preview_theme_id') || (
      window.Shopify?.designMode ? document.getElementById('tj-sd-filters')?.dataset.themeId || '' : ''
    );
  }

  let loading;
  async function load() {
    if (loading) return loading;
    loading = (async () => {
      const themeId = previewThemeId();
      async function page(number) {
        const url = new URL('/collections/all', location.origin);
        url.searchParams.set('view', 'fitment-index');
        url.searchParams.set('page', String(number));
        if (themeId) url.searchParams.set('preview_theme_id', themeId);
        const response = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Fitment index HTTP ${response.status}`);
        const data = await response.json();
        if (data.page !== number || !Array.isArray(data.products) || !Number.isInteger(data.pages)) {
          throw new Error('Fitment index page is invalid');
        }
        return data;
      }
      const first = await page(1);
      if (first.pages < 1 || first.pages > 100) throw new Error('Fitment index page count is invalid');
      const rest = await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => page(i + 2)));
      const products = [first, ...rest].flatMap((part) => part.products);
      if (!products.length) throw new Error('Fitment index has no products');
      const ids = products.map((product) => String(product.id));
      if (new Set(ids).size !== ids.length) throw new Error('Fitment index has duplicate product pages');
      return products;
    })().catch((error) => {
      loading = null;
      throw error;
    });
    return loading;
  }

  window.TJFitmentIndex = { load, expandProduct, canonicalMake, expandModels };
})();
